import "babel-polyfill";
import Vue from "vue";
import log from "loglevel";
import VeeValidate from "vee-validate";
import Vuetify from "vuetify";
import VueDisableInterpolation from "vue-disable-interpolation";

import * as components from "./components";
import * as containers from "./containers";

import "./css/custom.css";
import "./pages/style";

import ice from "./lib/ice";

import bugFill from "viewport-units-buggyfill";

// iOS safari の 100vh の値がおかしくなる対応
// refs: https://github.com/rodneyrehm/viewport-units-buggyfill#using-viewport-units-buggyfill
bugFill.init({ force: true });

if (process.env.NODE_ENV === "production") {
  log.setLevel("error");
} else {
  log.setLevel("debug");
}

const Clipfy = {
  install(Vue) {
    Object.values({ ...components, ...containers }).forEach(item => {
      Vue.component(item.name, item);
    });
  }
};

Vue.use(Vuetify);
Vue.use(Clipfy);
Vue.use(VeeValidate);
Vue.use(VueDisableInterpolation);

window.loglevel = log;
window.ice = ice;
